import React from "react";

// The Header creates links that can be used to navigate
// between routes.
const NoPage = () => (
    <div>
      <ul className="flex justify-center">
        404 not found
      </ul>
    </div>
);

export default NoPage;
